import script from "./ProjectComments.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectComments.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectComments.vue?vue&type=style&index=0&id=55993c78&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55993c78"]])

export default __exports__